import { u as p } from "../store/theme-store.ts.js";
import { jsx as l } from "react/jsx-runtime";
import { i } from "./icons-map.ts.js";
const u = (e) => {
  p.setState({ theme: e });
}, b = {
  updateTheme: u
};
function I(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
function m(e) {
  return e.split("-").map((o) => o.charAt(0).toUpperCase() + o.slice(1).toLowerCase()).join("");
}
const a = ({
  name: e,
  size: o,
  color: r,
  onClick: n,
  ...s
}) => {
  var t;
  const c = (t = i[m(e)]) != null ? t : null;
  return /* @__PURE__ */ l(c, { color: r, onClick: n, size: o, ...s });
};
a.displayName = "Icon";
const d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a
}, Symbol.toStringTag, { value: "Module" }));
export {
  b as I,
  I as a,
  d as b,
  m as t
};
//# sourceMappingURL=icon.js.map
